<!-- View Training Requests -->

<div class="bannerback">
    <app-nav></app-nav>
</div>


<app-skelitions [hidden]="!skeleton" [value]="6" class="mb-2"></app-skelitions>


<div [hidden]="skeleton" class="container-fluid bg-color">
    <div class="container">
        <section [hidden]="createCourseModal">
            <div class="d-flex justify-content-between pt-5">
                <div class="d-flex">
                    <img class="img-icon" src="../../../../assets/icons/SBC/inkpaper.svg" alt="loading">
                    <h2 class="font-600 color bottom-line p-0 dark-blue">{{"Course requests"| translator}}</h2>
                </div>
                <!-- <p-selectButton styleClass="d-flex justify-content-center" (onChange)="getTrainingRequests()"  [options]="statusOptions" [(ngModel)]="status" [multiple]="false" optionLabel="name" optionValue="value"></p-selectButton> -->
                <!-- <a [routerLink]="'/training/request'" class="create-training-btn mx-2 align-items-center d-flex">{{"Create a request"| translator}}<i class="pi pi-plus-circle mx-2"></i></a> -->
                <a [routerLink]="'/training/task-view'" class="create-training-btn mx-2 align-items-center d-flex px-4">Task</a>
            </div>
            <!-- breadcrumb -->
            <div class="d-flex flex-row align-items-center flex-wrap my-3 mx-3">
                <span class="d-flex align-items-center">
                    <span class="custom-bredcrum-btn d-flex align-items-center">
                        {{"Administration"| translator}}
                    </span>
                    <span class=""><i class="pi pi-fw pi-angle-left"></i></span>
                </span>
                <span class="d-flex align-items-center">
                    <span class="custom-bredcrum-btn font-600 d-flex align-items-center">
                        {{"Course requests"| translator}}
                    </span>
                </span>
            </div>
            <!-- breadcrumb end -->
        </section>
        <!-- Request cards start -->
        <section [hidden]="createTrainingModal || createCourseModal">
            <div class="pt-3">
                <p-selectButton styleClass="d-flex justify-content-center" (onChange)="getTrainingRequests()"
                    [options]="statusOptions" [(ngModel)]="status" [multiple]="false" optionLabel="name"
                    optionValue="value"></p-selectButton>
            </div>
            <div class="row py-3">
                <div *ngFor="let req of trainingRequestData" class="col-lg-3 col-md-6 col-sm-12 col-12 my-3">

                    <div class="card-shaddow">
                        <div class="flex-column">
                            <span>
                                <span class="d-flex justify-content-between">
                                    <span class="label-ui mt-2">

                                    <img  *ngIf="checkisImg(req.ou?.image_sq); else elseBlock"  src={{staticURL}}{{req.ou?.image}} 
                                        class="img-fluid p-1 tree-img-bg" style="max-height: 30px; max-width: 30px;">
                                    <ng-template #elseBlock>
                                        <i class="{{req.ou?.image_sq}} p-2" style="font-size: 1rem;"></i>
                                    </ng-template>
                                        
                                        {{req.topic}}</span>
                                    <span class="label-ui mt-2"><i [hidden]="req.status=='PENDING' || !req.trainingId"
                                            (click)="openCourse(req)" class="fa-solid fa-eye purply mx-2"></i></span>
                                </span>
                            </span>
                            <span class="label-data my-2">{{req.type.arabic}}</span>
                        </div>
                        <div class="flex-column">
                            <span class="description-responsive">
                                <span class="desc-heading">{{"the description"| translator}} :</span>
                                <p class="label-text">
                                    {{req?.description}}
                                </p>
                                <span *ngIf="req.status === 'REJECTED' || req?.status === 'REVISION'">
                                    <span class="desc-heading">{{"the reason"| translator}} :</span>
                                    <span class="label-text" [innerHTML]="req?.reason"></span>
                                </span>
                            </span>
                        </div>
                        <div class="py-3">
                            <div class="d-flex justify-content-center">
                                <div class="">
                                    <button *ngIf="req.status === 'PENDING' && hasPermission('COURSE','c')"
                                        (click)="requestHolder = req; selectionModal = true"
                                        class="create-training-btn mx-2">{{"construction"| translator}}<i
                                            class="pi pi-plus-circle mx-2"></i></button>
                                    <button
                                        *ngIf="req.status == 'TRAINING_CREATED' && hasPermission('TRAINING_REQUEST','u')"
                                        (click)="rejectReason =  true; rejectData.status = 'REVISION';rejectData._id = req._id"
                                        class="warn-btn m-1">{{"review"| translator}} <i
                                            class="pi pi-sync btns-icone mx-1"></i></button>
                                    <button styleClass="p-button-success m-1"
                                        *ngIf="req.status == 'TRAINING_CREATED' && hasPermission('TRAINING_REQUEST','u')"
                                        (click)="approve(req._id); " class="approve-btn">{{"Acceptance"| translator}} <i
                                            class="pi pi-check btns-icone mx-1"></i></button>
                                    <button styleClass="p-button-success"
                                        *ngIf="(req.status === 'TRAINING_CREATED' || req.status === 'PENDING') && hasPermission('TRAINING_REQUEST','u')"
                                        (click)="rejectReason =  true; rejectData.status = 'REJECTED';rejectData._id = req._id"
                                        class="reject-btn m-1">{{"to reject"| translator}}<i class="pi pi-times btns-icone mx-1"></i></button>
                                    <button styleClass="p-button-success"
                                        *ngIf="req.status === 'REVISION' && hasPermission('COURSE','u')"
                                        class="approve-btn m-1" (click)="openCourse(req)">{{"Release"| translator}}<i
                                            class="pi pi-pencil mx-2"></i></button>
                                    <button styleClass="p-button-success"
                                        *ngIf="req.status === 'REVISION' && hasPermission('COURSE','u')"
                                        class="reject-btn m-1" (click)="markedRevised(req._id)">{{"Reviewed"| translator}}<i
                                            class="pi pi-check-circle mx-2"></i></button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <app-no-data *ngIf="trainingRequestData.length <= 0 "></app-no-data>
            </div>
        </section>
        <!-- Request cards end -->
        <section [hidden]="!createTrainingModal">
            <app-create-training-form [data]="requestHolder"></app-create-training-form>
        </section>
        <section *ngIf="createCourseModal">
            <app-create-course [data]="requestHolder"></app-create-course>
        </section>
        <!--  Request cards end  -->
    </div>
</div>


<app-footer></app-footer>

<!-- Accept Reject Modal -->
<div class="card flex justify-content-center">
    <p-dialog [blockScroll]="true" [draggable]="false"header='{{"the reason"| translator}}' [(visible)]="rejectReason" [style]="{margin: '0rem 1rem',width:'95vw',maxWidth:'600px'}" [maximizable]="true">
        <div class="w-100">
            <p>{{"the reason"| translator}}</p>
            <p-editor [(ngModel)]="rejectData.reason" [style]="{'height':'320px'}"> </p-editor>
            <p *ngIf="reasonError" style="color: red;">{{reasonError}}</p>
        </div>
        <ng-template pTemplate="footer">
            <p-button icon="pi pi-check" (click)="deactivateInit()"  label='{{"OK" | translator}}'  styleClass="p-button-text"></p-button>
        </ng-template>
    </p-dialog>
</div>
<!-- End Accept Reject Modal -->

<!-- Training Selection Modal -->
<div class="container">

    <div class="card flex justify-content-center">
        <p-dialog [blockScroll]="true" [draggable]="false"header='{{"Choose Type"| translator}}' [(visible)]="selectionModal" [style]="{margin: '0rem 1rem'}" [maximizable]="true">
            <div class="w-100">
                <div *ngIf="hasPermission('COURSE','c')" class="create-course-ui"
                    (click)="createCourseModal = true ; selectionModal=false ">{{"Create a training course"| translator}}</div>
                <div class="create-course-ui" (click)="createTrainingModal = true ; selectionModal=false ">{{"Create a training program"| translator}}</div>
            </div>
        </p-dialog>
    </div>
</div>
<!-- End Training Selection Modal -->


<!-- Course View -->
<div class="card flex justify-content-center">
    <p-dialog [blockScroll]="true" [draggable]="false"header='{{"View course details"| translator}}' [(visible)]="openCourseModal" [style]="{margin: '0rem 1rem',width:'80vw'}"
        [maximizable]="true">
        <div class="w-100 bg-color border-4">
            <p-progressSpinner [hidden]="trainingDetails != undefined" styleClass="w-4rem h-4rem" strokeWidth="8"
                fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
            <app-show-detail [pageCall]="'View'" *ngIf="trainingDetails != undefined"
                [courseDetails]="trainingDetails"></app-show-detail>

        </div>
        <ng-template pTemplate="footer">
            <p-button icon="pi pi-check" (click)="openCourseModal=false;trainingDetails = undefined"  label='{{"OK" | translator}}' 
                styleClass="p-button-text"></p-button>
        </ng-template>
    </p-dialog>
</div>
<!-- Course -->

<p-confirmDialog [style]="{margin: '0rem 1rem'}"></p-confirmDialog>